// Wait for document to initialize
$(document).ready(function() {
  // Iterate through each contact form (there should be only one)
  $('.form-contact').each(function() {
    // Make neat reference to the form element
    var $form = $(this);

    // Check if the radio button should be prefilled
    var prefillMatches = window.location.search.match(/subject=(.+)/);

    // If a prefill match exists, then prefill matching radio button as checked
    if (prefillMatches && prefillMatches.length > 1) {
      $form.find(':input[value="'+decodeURIComponent(prefillMatches[1])+'"]').prop('checked', true);
    }

    // Register listener for the submit event
    $form.on('submit', function($event) {
      // Prevent default actions
      $event.preventDefault();
      $event.stopPropagation();

      // Get form items
      var formItems = $form.serializeArray();

      // Extract areas
      var areas = _(formItems)
        .filter(function(item) {
          return item.name === 'Area';
        })
        .pluck('value')
        .value();

      // Remove area fields from original form items 
      _.remove(formItems, function(item) {
        return item.name === 'Area';
      });

      // Re-add area concatnated form item
      formItems.unshift({
        name: 'Area',
        value: areas.join(', ')
      });

      // Make ajax post request, with the serialized form data
      $.ajax({
        type: 'POST',
        // Post to the url of the form action
        url: $form.attr('action'),
        data: $.param(formItems)
      }).done(function() {
        // Upon success, add submitted class to form
        $form.addClass('form-contact--submitted-success');
      }).fail(function() {
        // For now, we ignore fails, and accept them as success
        $form.addClass('form-contact--submitted-error');
      });

      // Return false for legacy purposes
      return false;
    });
  });
});


/*****************
 ** WEBPACK FOOTER
 ** ./source/js/form-contact.js
 ** module id = 5
 ** module chunks = 0
 **/